<template>
  <v-container fluid class="mb-12">
    <v-row
      v-if="!loop || index == 0"
      justify="center"
      align="center"
      class="mb-8"
    >
      <v-col
        class="ct-text-subtitle ct-text-bolder mb-0 d-flex justify-center align-center"
      >
        <span class="card-title" style="display:inline-block">
          {{ title }}
        </span>
      </v-col>
    </v-row>
    <v-row justify="center" align="start">
      <v-col
        v-show="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.md"
        cols="1"
        class="pa-0 consultAvatar"
        style="text-align: center"
      >
        <v-img
          alt="Vuetify Logo"
          class="shrink mx-auto mb-4"
          contain
          :src="cTitleImg(avatarIcon)"
          transition="scale-transition"
          width="90"
        />
        <!-- 20240704 Ben說隱藏 -->
        <div class="ct-text-subtitle3">{{ avatarName }}</div>
        <!-- <div class="ct-text-subtitle3">專家答覆</div> -->
      </v-col>
      <v-col cols="8" class="consultContent">
        <slot />
      </v-col>
      <v-col
        v-show="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.md"
        cols="1"
      />
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    avatarIcon: {
      type: String,
      default: "consult/icon_avatar_anonymous.svg"
    },
    avatarName: {
      type: String,
      default: "匿名"
    },
    title: {
      type: String,
      default: ""
    },
    loop: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    cTitleImg(val) {
      let path = val;
      return require(`@/assets/images/${path}`);
    }
  }
};
</script>
<style lang="scss" scoped>
.consultContent {
  background: #fdfdfd;
  border-radius: 20px;
  min-height: 75px;
}

.consultAvatar {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: calc((90px - 40px) / 2);
    right: -17.3px;
    height: 40px;
    width: 40px;
    border-style: solid;
    border-width: 20px 34.6px 20px 0;
    border-color: transparent white transparent transparent;
  }
}
</style>
